// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3COyV","col":"Table_col__3_PXz","fulfillmentStatus":"Table_fulfillmentStatus__3d2kK","emailCol":"Table_emailCol__28pyN"};